var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"floating-box",style:({ left: _vm.px(_vm.left), width: _vm.px(_vm.width), height: _vm.px(_vm.height) })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }